import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Helmet } from 'react-helmet-async';
// components
import Head from '../../components/UI/Head/Head';
import Playground from './components/playground/Playground';
import Price from './components/price/Price';
import Contact from '../../components/Contact/Contact';
import Faq from '../../components/Faq/Faq';
import Loader from '../../components/UI/Loader/Loader';
// style
import style from './arenaPage.module.css';

const ArenaPage = () => {
  const { id } = useParams();
  const [loadingPage, setLoadingPage] = useState(true);

  // Стартуем скролл и загрузку при монтировании
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  // Этот useEffect перезапускает загрузку при смене id
  useEffect(() => {
    setLoadingPage(true);
    document.body.style.overflow = 'hidden';

    const timer = setTimeout(() => {
      setLoadingPage(false);
      document.body.style.overflow = 'visible';
    }, 300);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = 'visible';
    };
  }, [id]); // ← ключевая часть

  return (
    <>
      <Helmet>
        <title>Площадка — Sparta Kazan</title>
        <meta
          name="description"
          content="Лазертаг, пейнтбол, гидробол и другие услуги от Sparta в Казани."
        />
      </Helmet>
      {loadingPage ? (
        <Loader />
      ) : (
        <main>
          {/* /header/ */}
          <Head url="/" />
          <div className={style.content}>
            {/* 1 */}
            <Playground id={id} />
            {/* 2 */}
            {id !== 'Vyezdnye-Igry-Kazan' && <Price id={id} />}
            {/* 3 */}
            <Contact
              bg={false}
              text=" Остались вопросы? Звоните или Отправьте заявку, всё
              обсудим!"
            />
            {/* 4 */}
            <Faq />
          </div>
          <ToastContainer />
        </main>
      )}
    </>
  );
};
export default ArenaPage;
